const $ = require('jquery');

const MapDot = require('../data/MapDot');
const MapDots = require('../data/MapDots');

const Ui = require('./Ui');

const constants = require('../data/constants');

class SegmentDrawer {
  constructor(map, eventDrawnCallback, localization) {
    this.mapObj = map;
    this.map = map.map;
    this.eventDrawnCallback = eventDrawnCallback;
    this.localization = localization;
    this.ctrlEnabled = false;
    this.drawingActive = false;
    this.drawingType = constants.DRAWING_TYPE_SEGMENT;
    this.dotsRenderer = null;
    this.lineToMouseRenderer = null;
    this.markerLayer = 22;
    this.dots = new MapDots();
    this.markers = [];
    this.polylines = [];
    this.initDrawSegmentElement = $('#initDrawSegment');
    this.initDrawStreetSegmentElement = $('#initDrawStreetSegment');
    this.initCutStreetElement= $('#initCutStreet');
    this.initDepotElement = $('#initDepot');
    this.cursorCircleMarker = $('.js-cursor-circle-marker')[0]; // eslint-disable-line
    this.mapMouseMoveListener = null;
    this.mapMouseClickListener = null;
    this.lastMousePostion = null;
    this.latestDot = null;
    this.addListeners();
  }

  deconstruct() {
    this.removeListeners();
    this.initDrawSegmentElement.off('click.segmentdraw');
    this.initDrawStreetSegmentElement.off('click.segmentdraw');
    this.initCutStreetElement.off('click.segmentdraw');
    this.initDepotElement.off('click.segmentdraw');
    $(document).off('keydown.segmentdraw.segment');
    $(document).off('keyup.segmentdraw.segment');
    $(document).off('keydown.segmentdraw.geometry');
    $(document).off('keyup.segmentdraw.geometry');

    this.mapObj.enableRightClickMove(false);
    if(this.dotsRenderer) {
      this.dotsRenderer.clearContainer();
    }
    if(this.lineToMouseRenderer) {
      this.lineToMouseRenderer.clearContainer();
    }
    this.map.getOverlayManager().getLayer(this.markerLayer).removeAllOverlays();
    this.cursorCircleMarker.style.visibility = 'hidden';
  }

  addListeners() {
    this.initDrawSegmentElement.on('click.segmentdraw', (e) => {
      e.preventDefault();
      if(this.drawingActive) return;

      Ui.showInfoBar('editor.titles.press-enter-to-finish');
      this.drawingType = constants.DRAWING_TYPE_SEGMENT;
      this.mapObj.enableRightClickMove(true);
      this.initDrawSegment();
    });

    this.initDrawStreetSegmentElement.on('click.segmentdraw', (e) => {
      e.preventDefault();
      if(this.drawingActive) return;

      Ui.showInfoBar('editor.titles.press-enter-to-finish');
      this.drawingType = constants.DRAWING_TYPE_GEOMETRY;
      this.mapObj.enableRightClickMove(true);
      this.initDrawSegment();
    });

    this.initCutStreetElement.on('click.segmentdraw', (e) => {
      e.preventDefault();
      if(this.drawingActive) return;

      Ui.showInfoBar('editor.titles.click-to-cut');
      this.drawingType = constants.DRAWING_TYPE_CUT;
      this.initCutStreet();
    });

    this.initDepotElement.on('click.segmentdraw', (e) => {
      e.preventDefault();
      if(this.drawingActive) return;

      let interval = setInterval(() => {
        $('.ctrl-info').toggleClass('bg-warning');
      }, 100);
      setTimeout(() => {
        clearInterval(interval);
      }, 600);

      Ui.showInfoBar('editor.titles.click-to-depot');
      this.drawingType = constants.DRAWING_TYPE_DEPOT;
      this.initCreateDepot();
    });

    $(document).on('keydown.segmentdraw.segment', (event) => {
      if (event.ctrlKey && !this.ctrlEnabled && !this.drawingActive) {
        this.drawingType = constants.DRAWING_TYPE_SEGMENT;
        this.initDrawSegment();
        this.ctrlEnabled = true;
        this.mapObj.enableRightClickMove(true);
      }
    });

    $(document).on('keydown.segmentdraw.geometry', (event) => {
      if(event.altKey && !this.ctrlEnabled && !this.drawingActive) {
        this.drawingType = constants.DRAWING_TYPE_GEOMETRY;
        this.initDrawSegment();
        this.ctrlEnabled = true;
        this.mapObj.enableRightClickMove(true);
      }
    });

    $(document).on('keyup.segmentdraw.segment', (event) => {
      if (event.keyCode === 17 && this.ctrlEnabled) {
        this.finishDrawing();
        this.ctrlEnabled = false;
        this.drawingType = constants.DRAWING_TYPE_SEGMENT;
      }
    });

    $(document).on('keyup.segmentdraw.geometry', (event) => {
      if(event.keyCode === 18 && this.ctrlEnabled) {
        this.finishDrawing();
        this.ctrlEnabled = false;
        this.drawingType = constants.DRAWING_TYPE_SEGMENT;
      }
    });

    $(document).on('keydown', (event) => {
      if(event.which === 27 && this.drawingActive) {
        this.stopDrawing();
      }
    })
  }

  drawLineToCursor() {
    this.lineToMouseRenderer.clearContainer();

    if (this.latestDot === null) return;

    const attributes = { stroke: '#818181', strokeWidth: 1.5, fillOpacity: 1 };

    const cursorCoordinate = this.map.getCurrentMapType()
      .getProjection()
      .pixelToMeter(new IWPoint(this.lastMousePostion.x, this.lastMousePostion.y));


    this.lineToMouseRenderer.drawLine(this.latestDot.coordinates, cursorCoordinate, attributes);

    this.lineToMouseRenderer.render();
  }

  finishDrawing(oldSegment) {

    // Without the timeout the click listener for initDrawSegmentElement gets fired again
    setTimeout(() => {
      this.drawingActive = false;
      this.mapObj.enableRightClickMove(false);
    }, 50);

    this.latestDot = null;
    this.lineToMouseRenderer.clearContainer();
    this.lineToMouseRenderer.render();
    this.cursorCircleMarker.style.visibility = 'hidden';

    if (this.dots.total >= 1) {
      this.eventDrawnCallback({
        left: this.lastMousePostion.x, top: this.lastMousePostion.y,
      }, this.dots.coordinates, this.drawingType, oldSegment);
    } else {
      this.clearDots();
    }

    Ui.hideInfoBar();
    this.removeListeners();
  }

  finishCutDrawing() {
    setTimeout(() => {
      this.drawingActive = false;
      this.mapObj.enableRightClickMove(false);
    }, 50);

    this.latestDot = null;
    this.cursorCircleMarker.style.visibility = 'hidden';

    this.eventDrawnCallback({
      left: this.lastMousePostion.x, top: this.lastMousePostion.y,
    }, this.dots.coordinates, this.drawingType);

    Ui.hideInfoBar();
    this.removeListeners();
  }

  finishDepotDrawing() {
    setTimeout(() => {
      this.drawingActive = false;
      this.mapObj.enableRightClickMove(false);
    }, 50);

    this.latestDot = null;
    this.lineToMouseRenderer.clearContainer();
    this.lineToMouseRenderer.render();
    this.cursorCircleMarker.style.visibility = 'hidden';

    this.eventDrawnCallback({
      left: this.lastMousePostion.x, top: this.lastMousePostion.y,
    }, this.dots.coordinates, this.drawingType);

    Ui.hideInfoBar();
    this.removeListeners();
  }

  stopDrawing() {
    setTimeout(() => {
      this.drawingActive = false;
      this.mapObj.enableRightClickMove(false);
    }, 50);
    this.latestDot = null;
    this.lineToMouseRenderer.clearContainer();
    this.lineToMouseRenderer.render();
    this.cursorCircleMarker.style.visibility = 'hidden';
    this.clearDots();
    Ui.hideInfoBar();
    this.removeListeners();
  }

  clearDots() {
    this.dotsRenderer.clearContainer();
    this.dotsRenderer.destroy();
    this.dotsRenderer = null;
    this.lineToMouseRenderer.destroy();
    this.lineToMouseRenderer = null;
    this.map.getOverlayManager().getLayer(this.markerLayer).removeAllOverlays();
  }

  removeListeners() {
    $(document).off('keypress.segmentdraw');
    this.initDrawSegmentElement.removeClass('active');
    this.initDrawStreetSegmentElement.removeClass('active');
    this.initCutStreetElement.removeClass('active');
    this.initDepotElement.removeClass('active');
    IWEventManager.removeListener(this.mapMouseMoveListener);
    IWEventManager.removeListener(this.mapMouseClickListener);
    $('body').off('contextmenu.undo');
  }

  getMousePositionFromIWEvent(event) {
    const mapPosition = this.map.getContainer().getBoundingClientRect();
    return {
      x: event.pageX - mapPosition.left,
      y: event.pageY - mapPosition.top,
    };
  }

  initDrawSegment() {
    this.drawingActive = true;
    // noinspection JSCheckFunctionSignatures
    this.dotsRenderer = new IWMapRenderer(this.map);
    // noinspection JSCheckFunctionSignatures
    this.lineToMouseRenderer = new IWMapRenderer(this.map);

    if(this.drawingType === constants.DRAWING_TYPE_GEOMETRY) {
      this.initDrawStreetSegmentElement.addClass('active').trigger('blur');
    } else if(this.drawingType === constants.DRAWING_TYPE_SEGMENT) {
      this.initDrawSegmentElement.addClass('active').trigger('blur');
    }

    this.dots = new MapDots();
    this.markers = [];

    // Listener that moves cursor circle and draw line to cursor if ctrl is pressed
    this.mapMouseMoveListener = IWEventManager.addDomListener(this.map.getContainer(), 'mousemove', (event) => {
      this.lastMousePostion = this.getMousePositionFromIWEvent(event);

      this.cursorCircleMarker.style.transform = `translate(${event.pageX}px,${event.pageY}px) scale(0.75, 0.75)`;

      this.cursorCircleMarker.style.visibility = 'visible';

      this.drawLineToCursor();
    });

    $(document).on('keypress.segmentdraw', (event) => {
      if (event.which === 13) {
        this.finishDrawing();
      }
    });

    // noinspection JSDeprecatedSymbols
    $('body').off('mouseup.undo').on(
      'mouseup.undo',
      this.map.getContainer(),
      this.mapMouseClickRightHandler.bind(this),
    );

    // noinspection JSDeprecatedSymbols
    this.mapMouseClickListener = IWEventManager.addListener(this.map, 'onclick', (event) => {
      const coordinates = this.map
        .getCurrentMapType()
        .getProjection()
        .pixelToMeter(event.position)
        .toWGS84();

      this.addAndRenderDot(coordinates);
    });
  }

  initCutStreet() {
    this.drawingActive = true;
    // noinspection JSCheckFunctionSignatures
    this.dotsRenderer = new IWMapRenderer(this.map);
    // noinspection JSCheckFunctionSignatures
    this.lineToMouseRenderer = new IWMapRenderer(this.map);

    this.initCutStreetElement.addClass('active').trigger('blur');

    this.dots = new MapDots();
    this.markers = [];

    this.mapMouseMoveListener = IWEventManager.addDomListener(this.map.getContainer(), 'mousemove', (event) => {
      this.lastMousePostion = this.getMousePositionFromIWEvent(event);

      this.cursorCircleMarker.style.transform = `translate(${event.pageX}px,${event.pageY}px) scale(0.75, 0.75)`;

      this.cursorCircleMarker.style.visibility = 'visible';
    });

    this.mapMouseClickListener = IWEventManager.addListener(this.map, 'onclick', (event) => {
      const coordinates = this.map
        .getCurrentMapType()
        .getProjection()
        .pixelToMeter(event.position)
        .toWGS84();

      this.addAndRenderDot(coordinates);
      this.finishCutDrawing();
    });

  }

  initCreateDepot() {
    let numberOfDots = 0;
    this.drawingActive = true;
    // noinspection JSCheckFunctionSignatures
    this.dotsRenderer = new IWMapRenderer(this.map);
    // noinspection JSCheckFunctionSignatures
    this.lineToMouseRenderer = new IWMapRenderer(this.map);

    this.initDepotElement.addClass('active').trigger('blur');

    this.dots = new MapDots();
    this.markers = [];

    this.mapMouseMoveListener = IWEventManager.addDomListener(this.map.getContainer(), 'mousemove', (event) => {
      this.lastMousePostion = this.getMousePositionFromIWEvent(event);

      this.cursorCircleMarker.style.transform = `translate(${event.pageX}px,${event.pageY}px) scale(0.75, 0.75)`;

      this.cursorCircleMarker.style.visibility = 'visible';
    });

    this.mapMouseClickListener = IWEventManager.addListener(this.map, 'onclick', (event) => {
      const coordinates = this.map
        .getCurrentMapType()
        .getProjection()
        .pixelToMeter(event.position)
        .toWGS84();

      this.addAndRenderDot(coordinates);
      numberOfDots++;

      if(numberOfDots === 2) {
        this.finishDepotDrawing();
        return;
      }

      let interval = setInterval(() => {
        $('.ctrl-info').toggleClass('bg-warning');
      }, 100);
      setTimeout(() => {
        clearInterval(interval);
      }, 600);

      Ui.showInfoBar('editor.titles.click-to-depot-2');
    });

    $(document).on('keypress.segmentdraw', (event) => {
      if (event.which === 13) {
        this.finishDepotDrawing();
      }
    });
  }

  initDrawSegmentFromSegment(segment) {
    if(this.drawingActive) return;

    Ui.showInfoBar('editor.titles.press-enter-to-finish');
    this.drawingType = constants.DRAWING_TYPE_GEOMETRY;
    this.mapObj.enableRightClickMove(true);

    this.drawingActive = true;
    // noinspection JSCheckFunctionSignatures
    this.dotsRenderer = new IWMapRenderer(this.map);
    // noinspection JSCheckFunctionSignatures
    this.lineToMouseRenderer = new IWMapRenderer(this.map);

    this.initDrawStreetSegmentElement.addClass('active').trigger('blur');

    this.dots = new MapDots();
    this.markers = [];

    // Listener that moves cursor circle and draw line to cursor if ctrl is pressed
    this.mapMouseMoveListener = IWEventManager.addDomListener(this.map.getContainer(), 'mousemove', (event) => {
      this.lastMousePostion = this.getMousePositionFromIWEvent(event);

      this.cursorCircleMarker.style.transform = `translate(${event.pageX}px,${event.pageY}px) scale(0.75, 0.75)`;

      this.cursorCircleMarker.style.visibility = 'visible';

      this.drawLineToCursor();
    });

    $(document).on('keypress.segmentdraw', (event) => {
      if (event.which === 13) {
        this.finishDrawing(segment);
      }
    });

    // noinspection JSDeprecatedSymbols
    $('body').off('mouseup.undo').on(
      'mouseup.undo',
      this.map.getContainer(),
      this.mapMouseClickRightHandler.bind(this),
    );

    segment._coordinates.forEach(coord => {
      this.addAndRenderDot(coord);
    });

    // noinspection JSDeprecatedSymbols
    this.mapMouseClickListener = IWEventManager.addListener(this.map, 'onclick', (event) => {
      const coordinates = this.map
        .getCurrentMapType()
        .getProjection()
        .pixelToMeter(event.position)
        .toWGS84();

      this.addAndRenderDot(coordinates);
    });
  }

  addAndRenderDot(coordinates) {
    this.latestDot = new MapDot(coordinates);
    const dotIndex = this.dots.add(this.latestDot);

    // noinspection JSCheckFunctionSignatures
    const marker = new IWClassMarker(this.map, coordinates.toMercator());
    marker.setHotspot(new IWPoint(9, 9));
    marker.setClassName('dot-marker');
    this.markers[dotIndex] = marker;

    // noinspection JSUndefinedPropertyAssignment
    marker.onContextMenu = (e) => {
      e.preventDefault();
      this.mapMouseClickRightHandler();
    };

    this.map.getOverlayManager().getLayer(this.markerLayer).addOverlay(marker);

    const previousDot = this.dots.getPreviousDot(dotIndex);

    if (previousDot) {
      this.polylines[dotIndex] = this.dotsRenderer.drawPolyline(
        [coordinates, previousDot.coordinates],
        { stroke: '#6b6b6b', strokeWidth: 2, strokeOpacity: 1 },
      );

      this.dotsRenderer.render();
    }
  }

  mapMouseClickRightHandler(event) {
    if(event.button !== 1 || this.dots.total < 1) {
      return;
    }

    const indexToRemove = this.dots.getLastDotIndex();
    this.dots.removeByIndex(indexToRemove);
    this.map.getOverlayManager().getLayer(this.markerLayer).removeOverlay(
      this.markers[indexToRemove],
    );

    this.redrawLinesBetweenDots();

    if (indexToRemove > 0) {
      this.latestDot = this.dots.getPreviousDot(indexToRemove);
    } else {
      this.latestDot = null;
    }

    this.drawLineToCursor();
  }

  redrawLinesBetweenDots() {
    this.dotsRenderer.clearContainer();

    this.dots.get().forEach((dot, index) => {
      const previousDot = this.dots.getPreviousDot(index);

      if (!previousDot) return;

      this.dotsRenderer.drawPolyline(
        [dot.coordinates, previousDot.coordinates],
        { stroke: '#6b6b6b', strokeWidth: 2, strokeOpacity: 1 },
      );
    });

    this.dotsRenderer.render();
  }
}

module.exports = SegmentDrawer;
